// @flow
import type {Node} from 'react'
import React, {Component} from 'react'
import UICheckbox from 'components/ui/Inputs/Checkbox'

import type {Path, UpdateCallback} from 'components/proposals/types'

type Props = {
  checked: boolean,
  disabled: boolean,
  label: string,
  onChange: UpdateCallback,
  path: Path,
  tabIndex: number,
  id: ?string,
}

class Checkbox extends Component<Props> {
  static defaultProps: { id: null, tabIndex: number } = {
    tabIndex: -1,
    id: null,
  }

  onChange: ((value: boolean) => void) = (value: boolean) => this.props.onChange(this.props.path, value)

  onKeyPress: ((event: SyntheticKeyboardEvent<>) => void) = (event: SyntheticKeyboardEvent<>) => {
    if (event.key === 'Enter')
      this.onChange(!this.props.checked)
  }

  render(): Node {
    return (
      <UICheckbox
        checked={this.props.checked}
        disabled={this.props.disabled}
        label={this.props.label}
        onChange={this.onChange}
        onKeyPress={this.onKeyPress}
        tabIndex={this.props.tabIndex}
        id={this.props.id}
      />
    )
  }
}

export default Checkbox
